module.exports = __webpack_public_path__ + "img/35.fa2be0d2.png";